var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.11 6.1L10.56 0L0 6.1V18.28L10.56 24.38L21.11 18.28V6.1Z",
    fill: "#4F80DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4397 6.82997C14.4397 4.69815 12.7116 2.96997 10.5797 2.96997C8.44792 2.96997 6.71973 4.69815 6.71973 6.82997V18.42C6.71973 20.5518 8.44792 22.28 10.5797 22.28C12.7116 22.28 14.4397 20.5518 14.4397 18.42V6.82997Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.93 6.33998C14.93 4.20816 13.2018 2.47998 11.07 2.47998C8.93816 2.47998 7.20996 4.20816 7.20996 6.33998V17.93C7.20996 20.0618 8.93816 21.79 11.07 21.79C13.2018 21.79 14.93 20.0618 14.93 17.93V6.33998Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0006 10.2H11.2591C10.6355 10.2 10.1299 10.8715 10.1299 11.7C10.1299 12.5284 10.6355 13.2 11.2591 13.2H19.0006C19.6243 13.2 20.1299 12.5284 20.1299 11.7C20.1299 10.8715 19.6243 10.2 19.0006 10.2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2094 5.70006C12.2094 5.07045 11.7013 4.56006 11.0745 4.56006C10.4476 4.56006 9.93945 5.07045 9.93945 5.70006V7.96006C9.93945 8.58966 10.4476 9.10006 11.0745 9.10006C11.7013 9.10006 12.2094 8.58966 12.2094 7.96006V5.70006Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandle);
export default __webpack_public_path__ + "static/media/handle.0e20a460.svg";
export { ForwardRef as ReactComponent };